/* istanbul ignore file */
/* tslint:disable */
 
import type { PaginatedSettingsList } from '../models/PaginatedSettingsList';
import type { Settings } from '../models/Settings';
import type { UpdateSettingValue } from '../models/UpdateSettingValue';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class SettingsService {

  /**
   * @param page A page number within the paginated result set.
   * @param pageSize Number of results to return per page.
   * @returns PaginatedSettingsList 
   * @throws ApiError
   */
  public static settingsList(
page?: number,
pageSize?: number,
): CancelablePromise<PaginatedSettingsList> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/settings/',
      query: {
        'page': page,
        'page_size': pageSize,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns Settings 
   * @throws ApiError
   */
  public static settingsCreate(
requestBody: Settings,
): CancelablePromise<Settings> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/settings/',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @param id 
   * @returns Settings 
   * @throws ApiError
   */
  public static settingsRetrieve(
id: string,
): CancelablePromise<Settings> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/settings/{id}/',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns UpdateSettingValue 
   * @throws ApiError
   */
  public static settingsUpdate(
id: string,
requestBody: UpdateSettingValue,
): CancelablePromise<UpdateSettingValue> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/settings/{id}/',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @param id 
   * @returns void 
   * @throws ApiError
   */
  public static settingsDestroy(
id: string,
): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/settings/{id}/',
      path: {
        'id': id,
      },
      errors: {
        405: `No response body`,
      },
    });
  }

}
